import React from "react";
import { Pie } from "react-chartjs-2";
import { graphColors } from "../../../../services/entity/chart/chart-service";

export const PieChart = ({ chartData }) => {
  const values = chartData.points.map((point) => point.value);
  let labels;
  try {
    labels = JSON.parse(chartData.chartData.series_name);
  } catch (err) {
    labels = chartData.points.map((point) => point.value + "%");
  }

  const data = {
    labels,
    datasets: [
      {
        data: values,
        backgroundColor: graphColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutoutPercentage: 0,
    legend: { position: "top" },
    tooltips: {
      callbacks: {
        label: function (tooltipItem, data) {
          const ds = data.datasets[tooltipItem.datasetIndex];
          const total = ds.data.reduce((a, b) => a + b, 0);
          const value = ds.data[tooltipItem.index];
          const pct = ((value / total) * 100).toFixed(1);
          const label = data.labels[tooltipItem.index] || "";
          return `${label}: ${value} (${pct}%)`;
        },
      },
    },
  };

  return (
    <div className="relative w-1/2 h-1/2">
      <Pie data={data} options={{ ...options }} />
    </div>
  );
};